<script setup>
import { useFiltersScroll } from './useFiltersScroll';

const { handleButtonClick } = useFiltersScroll({ direction: 'up' });
</script>

<template>
  <div
    class="filtersScrollBtn filtersScrollBtn--up"
    @click="handleButtonClick"
  >
    <div class="filtersScrollBtn__arrows" />
  </div>
</template>
